import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const HubStockDetailRBAC = {
  pageID: 'ce08b45bc6ba9ce0617f251c7d8094e1',
  elementID: {
    BtnAddProduct: '27be4456a56751b3c5cc839a522b5aa5',
    BtnUpdateExpiryDate: '1a74961b21b60a0df85026bcdbc09d9d',
    BtnStockInSearch: '38afbfd509d6108c8538e54cd06e50fe',
    BtnPrintQR: '29ff0a97fbcf5428757d42453fbad35d',
    BtnUpdateProduct: '41b7102dd7ac0a2b2bee7cdc4db679ad',
    UpdateQtyInRow: '2d528647eb94874c8dc38c6553da1269',
    UpdateSlocInRow: '721a23b6fcc27b2741d0d04987a3a418',
    UpdateStatusInRow: 'e63c75dcfe6827e27ceccdaf2c4cd17b',
    UpdateLostToAvailableInRow: 'c6eb97056e23197968e0f4a3ab8d281b',
  },
} as const

export const useRBACHubStockDetailPage = createUseRBAC(HubStockDetailRBAC.elementID)

export type UseRBACHubStockDetailPageType = ReturnType<typeof useRBACHubStockDetailPage>
